import * as BABYLON from "babylonjs";
import AssetLoader from "../loaders/AssetLoader";
import Present from "./Present";
import Boost from "./Boost";
import Rock from "./Rock";
import Obstacle from "./Obstacle";
import TimeBonus from "./TimeBonus";
import Tree from "./Tree";
import Snowmen from "./Snowmen";
import Star from "./Star";
import Snowball from "./Snowball";
import IcePatch from "./IcePatch";
const OFFSET = 500;

class Level {
  constructor(key, type, data) {
    this.key = key;
    this.type = type;
    this.view = new BABYLON.TransformNode("level" + key);
    this.view.rotationQuaternion = null;

    this.presents = [];
    this.rocks = [];
    this.boosts = [];
    this.time = [];
    this.trees = [];
    this.snowmen = [];
    this.obstacles = [];
    this.dividers = [];
    this.colliders = [];
    this.icePatches = [];
    this.stars = [];
    this.snowballs = [];
    this.currentPresent = 0;

    data.forEach((item, index1) => {
      const config = this.normalizeData(item);

      if (item.label.includes("Pressent")) {
        // const index = Math.floor(Math.random() * 5) + 1;
        const isNewPowerUp = Math.random() < 0.5;
        // const isNewPowerUp = true;
        const index = Math.floor(Math.random() * 3) + 1;
        let mesh = null;
        if (isNewPowerUp) {
          if (index === 1) mesh = AssetLoader.getModel("Watch").meshes[1];
          else if (index === 2) mesh = AssetLoader.getModel("Headphones").meshes[1];
          else mesh = AssetLoader.getModel("Phone").meshes[1];
        } else mesh = AssetLoader.getModel("Presents").meshes[index];

        // if(mesh.name==="aaa") isNewPowerUp=true;

        mesh.rotationQuaternion = null;

        const newMesh = mesh.createInstance(item.label);
        // const present = new Present(newMesh, this.presents.length, index);
        const present = new Present(
          newMesh,
          // this.currentPresent,
          index,
          this.key,
          isNewPowerUp
        );
        this.currentPresent++;
        present.view.parent = this.view;

        present.setConfig(config);

        this.presents.push(present);
      }

      if (item.label.includes("Boost")) {
        const mesh = AssetLoader.getModel("Boost"); //.meshes[0];
        console.log("BOOST!:", mesh);
        const boost = new Boost(
          mesh.meshes[0],
          this.boosts.length,
          mesh.animations
        );
        boost.view.parent = this.view;
        boost.setConfig(config);
        this.boosts.push(boost);
      }

      if (item.label.includes("Time")) {
        //"Time"
        // const mesh = AssetLoader.getModel("ExtraTime").meshes[1];
        console.log("TIME OBJECT:", AssetLoader.getModel("ExtraTime").meshes);
        const mesh = AssetLoader.getModel("ExtraTime").meshes[1]; //1
        const newMesh = mesh.createInstance(item.label + this.time.length);
        const mesh2 = AssetLoader.getModel("ExtraTime").meshes[2]; //1
        const newMesh2 = mesh2.createInstance(
          item.label + this.time.length + "-2"
        );
        const time = new TimeBonus(newMesh, newMesh2);
        time.view.parent = this.view;
        time.setConfig(config);
        this.time.push(time);
      }

      if (item.label.includes("Snowman")) {
        Snowmen.placeSnowman(config, this.view);
      }

      if (item.label.includes("Tree")) {
        const rdm = Math.floor(Math.random() * 3);
        const mesh = AssetLoader.getModel("Trees").meshes[rdm + 1];
        const tree = new Tree(mesh);
        tree.view.parent = this.view;
        tree.setConfig(config);
        this.trees.push(tree);

        if (!item.label.includes("_SD")) {
          this.colliders.push(tree.collider);
        }
      }

      if (item.label.includes("Stalagmite")) {
        const rdm = Math.floor(Math.random() * 3);
        const mesh = AssetLoader.getModel("Stalagmites").meshes[rdm + 1];
        const tree = new Tree(mesh,item.label);
        tree.view.parent = this.view;
        tree.setConfig(config);
        this.trees.push(tree);

        if (!item.label.includes("_SD")) {
          this.colliders.push(tree.collider);
        }
      }

      if (item.label.includes("Store")) {
        const mesh = AssetLoader.getModel("Store").meshes[1];

        const newMesh = mesh.createInstance(item.label);
        newMesh.parent = this.view;
        newMesh.rotationQuaternion = null;

        newMesh.rotation = config.rotation;
        newMesh.position = config.position;
        newMesh.scaling = config.scaling;
      }

      if (item.label.includes("Rock") || item.label.includes("Crystal")) {
        const index = item.label.includes("Crystal") ? 2 : 1;

        const mesh = AssetLoader.getModel("Rocks").meshes[index];

        const newMesh = mesh.createInstance(item.label);
        newMesh.parent = this.view;
        newMesh.rotationQuaternion = null;

        newMesh.rotation = config.rotation;
        newMesh.position = config.position;
        newMesh.scaling = config.scaling;

        this.rocks.push(new Rock(newMesh));
      }

      // may need to switch this if we're lighting them up (or just mod rocks)
      if (item.label.includes("Geode")) {
        console.log("GEODES:",AssetLoader.getModel("Geodes").meshes[1].name);
        const mesh = AssetLoader.getModel("Geodes").meshes[1];
        const newMesh = mesh.createInstance(item.label);
        newMesh.parent = this.view;
        newMesh.rotationQuaternion = null;
        newMesh.rotation = config.rotation;
        newMesh.position = config.position;
        // newMesh.scaling = config.scaling;
        newMesh.scaling = new BABYLON.Vector3(config.scaling.x*70,config.scaling.y*70,config.scaling.z*70);

        this.rocks.push(new Rock(newMesh));
      }

      if (item.label.includes("Snowball")) {
        // console.log("SNOWBALL:", AssetLoader.getContainer("Snowball").meshes);
        const template = AssetLoader.getContainer("Snowball");
        const snowball = new Snowball(template);
        snowball.view.parent = this.view;
        snowball.setConfig(config);
        this.snowballs.push(snowball);
      }

      if (item.label.includes("Icepatch")) {
        // console.log("ICE PATCH:", AssetLoader.getModel("IcePatch").meshes);
        const mesh = AssetLoader.getModel("IcePatch").meshes[1];
        const newMesh = mesh.createInstance(item.label);
        const mesh2 = AssetLoader.getModel("IcePatch").meshes[2];
        const newMesh2 = mesh2.createInstance(item.label);
        const icePatch = new IcePatch(newMesh, newMesh2);
        icePatch.view.parent = this.view;
        icePatch.setConfig(config);
        this.icePatches.push(icePatch);
      }

      if (item.label.includes("Star")) {
        const mesh = AssetLoader.getModel("Star").meshes[1];
        // console.log("STAR:", AssetLoader.getModel("Star").meshes);
        const newMesh = mesh.createInstance(item.label);
        const star = new Star(newMesh);
        star.view.parent = this.view;
        star.setConfig(config);
        this.stars.push(star);
      }

      if (item.label.includes("Drift")) {
        let index = 1;
        if (item.label.includes("_2_")) {
          index = 2;
        } else if (item.label.includes("_3_")) {
          index = 3;
        }

        // if isCave we grab DriftsCave
        let baseMesh = null;
        baseMesh = AssetLoader.getModel("Drifts").meshes[6 + index];

        // if (item.label.includes("Cave")) baseMesh = AssetLoader.getModel("DriftsCave").meshes[6 + index];
        // else baseMesh = AssetLoader.getModel("Drifts").meshes[6 + index];

        if (item.label.includes("Cave")) {
          for (
            let i = 0;
            i < AssetLoader.getModel("DriftsCave").meshes.length;
            i++
          ) {
            let m = AssetLoader.getModel("DriftsCave").meshes[i];
            if (m.name === "Drift" && index === 1) baseMesh = m;
            if (m.name === "Drift_2" && index === 2) baseMesh = m;
            if (m.name === "Drift_3" && index === 3) baseMesh = m;
          }
        } else {
          for (
            let i = 0;
            i < AssetLoader.getModel("Drifts").meshes.length;
            i++
          ) {
            let m = AssetLoader.getModel("Drifts").meshes[i];
            if (m.name === "Drift" && index === 1) baseMesh = m;
            if (m.name === "Drift_2" && index === 2) baseMesh = m;
            if (m.name === "Drift_3" && index === 3) baseMesh = m;
          }
        }

        const isStatic = item.label.includes("_SD");

        const drift = new Obstacle(baseMesh, item.label, isStatic);
        drift.view.parent = this.view;
        drift.setConfig(config);
        this.obstacles.push(drift);
        baseMesh.isVisible=false;
        drift.view.isVisible=false;
        if (!isStatic && index === 1) {
          drift.createColliders();
          this.colliders.push(...drift.colliders);
        }
      }

      if (item.label.includes("Icewall_Small")) {
        let baseMesh = null;
        let meshes = null;
        if (item.label.includes("Cave"))
          meshes = AssetLoader.getModel("IcewallsCave").meshes;
        else meshes = AssetLoader.getModel("Icewalls").meshes;
        for (let i = 0; i < meshes.length; i++)
          if (meshes[i].name === "IceWall_Small") baseMesh = meshes[i];

        // const baseMesh =
        //   AssetLoader.getModel("Icewalls").meshes[0].getChildren()[1];

        const isStatic = item.label.includes("_SD");

        const wall = new Obstacle(baseMesh, item.label, isStatic);
        wall.view.parent = this.view;
        wall.setConfig(config);
        this.obstacles.push(wall);

        if (!isStatic) {
          wall.createColliders();
          this.colliders.push(...wall.colliders);
        }
      }

      if (item.label.includes("Icewall_Divider")) {
        // const mesh =
        //   AssetLoader.getModel("Icewalls").meshes[0].getChildren()[2];

        let mesh = null;
        let meshes = null;
        if (item.label.includes("Cave"))
          meshes = AssetLoader.getModel("IcewallsCave").meshes;
        else meshes = AssetLoader.getModel("Icewalls").meshes;
        for (let i = 0; i < meshes.length; i++)
          if (meshes[i].name === "IceWall_Divider") mesh = meshes[i];

        const newMesh = mesh.createInstance(item.label);
        newMesh.parent = this.view;
        newMesh.rotationQuaternion = null;

        newMesh.rotation = config.rotation;
        newMesh.position = config.position;
        newMesh.scaling = config.scaling;

        if (!item.label.includes("_SD")) {
          this.colliders.push(newMesh);
        } else {
          this.dividers.push(newMesh);
        }
      }

      if (item.label.includes("Icewall_Large")) {
        // const baseMesh =
        //   AssetLoader.getModel("Icewalls").meshes[0].getChildren()[0];
        const isStatic = item.label.includes("_SD");

        let baseMesh = null;
        let meshes = null;
        if (item.label.includes("Cave"))
          meshes = AssetLoader.getModel("IcewallsCave").meshes;
        else meshes = AssetLoader.getModel("Icewalls").meshes;
        for (let i = 0; i < meshes.length; i++)
          if (meshes[i].name === "Icewall_Large") baseMesh = meshes[i];

        const wall = new Obstacle(baseMesh, item.label, isStatic);
        wall.view.parent = this.view;
        wall.setConfig(config);
        this.obstacles.push(wall);

        if (!isStatic) {
          wall.createColliders();
          this.colliders.push(...wall.colliders);
        }
      }

      if (item.label.includes("BoxCollider")) {
        const newMesh = BABYLON.MeshBuilder.CreateBox("BC_" + item.label, {
          width: 4,
          height: 4,
          depth: 8,
          faceColors: [
            new BABYLON.Color3(0, 0, 1),
            new BABYLON.Color3(0, 0, 1),
            new BABYLON.Color3(0, 0, 1),
            new BABYLON.Color3(0, 0, 1),
            new BABYLON.Color3(0, 0, 1),
            new BABYLON.Color3(0, 0, 1),
          ],
        });
        newMesh.isVisible = false;
        newMesh.isPickable = true;
        newMesh.parent = this.view;
        newMesh.rotationQuaternion = null;

        newMesh.rotation = config.rotation;
        newMesh.position = config.position;
        newMesh.scaling = config.scaling;

        this.colliders.push(newMesh);
      }
    });
  }

  normalizeData(item) {
    return {
      // REVERSED IN .JSON!!!! X Z Y!!!!
      position: new BABYLON.Vector3(
        -item.location[0] * 0.01, // X
        item.location[2] * 0.01 + OFFSET, // Y
        item.location[1] * 0.01 // Z
      ),
      rotation: new BABYLON.Vector3(
        item.rotation[0] * (Math.PI / 180),
        item.rotation[2] * (Math.PI / 180),
        -item.rotation[1] * (Math.PI / 180)
      ),
      scaling: new BABYLON.Vector3(
        -item.scale[0],
        item.scale[1],
        item.scale[2]
      ),
    };
  }

  reset() {
    this.presents.forEach((present) => {
      present.reset();
    });
    this.time.forEach((timeItem) => {
      timeItem.reset();
    });
    this.boosts.forEach((boost) => {
      boost.reset();
    });
    this.rocks.forEach((rock) => {
      rock.reset();
    });
  }

  destroy() {
    this.presents.forEach((present) => {
      present.destroy();
    });
    this.time.forEach((timeItem) => {
      timeItem.destroy();
    });
    this.boosts.forEach((boost) => {
      boost.destroy();
    });
    this.rocks.forEach((rock) => {
      rock.destroy();
    });
    this.trees.forEach((tree) => {
      tree.destroy();
    });
    this.colliders.forEach((collider) => {
      collider.parent = null;
      collider.isVisible = false;
      collider.isCollidable = false;
      collider.dispose();
    });
    this.dividers.forEach((wall) => {
      wall.parent = null;
      wall.isVisible = false;
      wall.dispose();
    });
    this.obstacles.forEach((obstacle) => {
      obstacle.destroy();
    });
    this.icePatches.forEach((icePatch) => {
      icePatch.destroy();
    });
    this.stars.forEach((star) => {
      star.destroy();
    });
    this.snowballs.forEach((snowball) => {
      snowball.destroy();
    });
    this.snowmen.forEach((snowman) => {
      snowman.destroy();
    });

    // this.view.dispose()
  }
}

export default Level;
